import React from 'react'
import { Stack, Typography } from '@mui/material'
import { getFeeDescription } from '../utils/getFeeDescription'
import { IssueEntity } from 'types/IssueEntity'
import { Fee } from 'types/FeeEntity'

function feeLevelName(fees: Array<Fee>, feeLevel: number) {
    const isTopDown = !!fees.find((f) => f.feeLevel === feeLevel)?.topDown
    const topDown = isTopDown ? ' (topdown)' : ''
    if (!fees.some((f) => Number(f.feeLevel) > 1)) {
        return 'garantiåtagare' + topDown
    }
    if (!fees.some((f) => Number(f.feeLevel) > 2)) {
        return feeLevel === 1 ? 'bottengaranti' + topDown : 'toppgaranti' + topDown
    }
    return `garantinivå ${feeLevel}` + topDown
}

function FeesInformation({ issue }: { issue: Pick<IssueEntity, 'fees'> }) {
    let fees = issue.fees
    if (!fees || fees.length === 0 || !fees.some((fee) => Number(fee.feeLevel) > 0)) return null
    fees = fees
        .filter((fee) => Number(fee.feeLevel) > 0)
        .sort((a, b) => (Number(a.feeLevel) > Number(b.feeLevel) ? 1 : -1))

    return (
        <Stack spacing={2} direction='column'>
            {fees.map((fee) => (
                <Typography key={fee.id}>
                    Ersättningsnivå för {feeLevelName(fees, Number(fee.feeLevel))}:{' '}
                    {getFeeDescription(fee) || 'Ingen ersättning utgår.'}
                </Typography>
            ))}
        </Stack>
    )
}

export { FeesInformation, feeLevelName }
